import React from 'react'

const Chile = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <rect
            x="4.4"
            y="4.4"
            width="31.2"
            height="31.2"
            rx="15.6"
            stroke="#BCBCBC"
            strokeWidth="0.8"
        />
        <mask
            id="footer-flag-chile"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="25"
        >
            <path
                d="M20 32.3672C26.6274 32.3672 32 26.9946 32 20.3672C32 13.7398 26.6274 8.36719 20 8.36719C13.3726 8.36719 8 13.7398 8 20.3672C8 26.9946 13.3726 32.3672 20 32.3672Z"
                fill="white"
            />
        </mask>
        <g mask="url(#footer-flag-chile)">
            <path d="M48.4872 8.34766H8.0166V20.4029H48.4872V8.34766Z" fill="white" />
            <path
                d="M20.1991 8.34766H8.0166V20.4029H20.1991V8.34766Z"
                fill="#626BB1"
            />
            <path
                d="M14.8886 16.1029L13.0063 17.2842L13.5489 15.1281L11.8418 13.702L14.0603 13.5531L14.8886 11.4883L15.7169 13.5531L17.9354 13.702L16.2308 15.1281L16.7734 17.2842L14.8886 16.1029Z"
                fill="white"
            />
            <path
                d="M48.4872 20.4023H8.0166V32.4576H48.4872V20.4023Z"
                fill="#E15355"
            />
        </g>
    </svg>
)

export default Chile
